import React from 'react'

import * as S from './styles'

import type { KeyboardEvent, MouseEvent } from 'react'

export type ToggleProps = {
  onClick: () => void
  isChecked: boolean
  isDisabled?: boolean
  label?: string
}

// This is a decoupled component. Only UI. No dependencies on any other components.
export const ToggleDecoupled = ({
  onClick,
  isChecked,
  isDisabled = false,
  label,
}: ToggleProps) => {
  const handleClick: any = (e: MouseEvent<HTMLDivElement>) => {
    if (isDisabled) return
    onClick?.()
    e.stopPropagation()
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (isDisabled) return
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      e.stopPropagation()
      onClick?.()
    }
  }

  return (
    <S.StyledToggle
      isChecked={isChecked}
      isDisabled={isDisabled}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={isDisabled ? -1 : 0}
      role="switch"
      aria-checked={isChecked}
      aria-disabled={isDisabled}
      data-testid="toggle"
      data-value={isChecked}
    >
      <S.ToggleTrack isChecked={isChecked} isDisabled={isDisabled}>
        <S.ToggleThumb isChecked={isChecked} isDisabled={isDisabled} />
      </S.ToggleTrack>
      {label && <div>{label}</div>}
    </S.StyledToggle>
  )
}
